<div id="container">
    <app-header-title [title]="project.title" contenteditable="true" id="{{project.id}}" (blur)="updateTitle()"></app-header-title>
    <app-header-context (click)="warnUser()"></app-header-context>
</div>
